<template>
  <div class="message" :class="isScroll?'':'isBackground'">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <div class="messageNav">
          <ul>
            <li v-for="(item,index) in messageList" :class="{checked:tabIndex==item.type}" @click="tabClick(index,item.type)"><span>{{ item.name }}</span></li>
          </ul>
        </div>
        <div v-if="list.noticeRecordList" class="messageCon">
          <ul v-if="list.noticeRecordList.length>0">
            <li v-for="(item,index) in list.noticeRecordList" @click="goMessageDetail(item.id)">
              <div class="itemTit"><span>[{{ item.type }}]{{ item.title }}</span><span v-if="item.isNewNotice" class="sign">NEW</span></div>
              <div class="item" v-html="item.content" />
              <div class="itemTime"><em>{{ new Date((item.validFrom).replace(/-/g, "/")).format("Y-MM-dd") }}</em><a>查看详情>></a></div>
            </li>
          </ul>
          <noData v-else />
          <div v-if="list.noticeRecordList.length>0" class="more" :class="moreClass" @click="clickMore"><span>{{ moreTxt }}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require('@/assets/css/message.css')
import Header from '@/view/module/Header.vue'
import noData from '@/view/module/noData.vue'
import '@/utils/tradeDataUtil'
import api from '@/plugins/api'
import { mapState } from 'vuex'
export default {
  name: 'MessageCenter',
  components: { Header, noData },
  computed: {
    ...mapState(['tabIndex']),
    moreClass: {
      get() {
        let classType = ''
        if (this.list.noticeRecordList) {
          if (this.list.noticeRecordList.length >= 10 && this.list.totalPage > 1) {
            this.moreTxt = '加载更多'
            classType = ''
          } else {
            this.moreTxt = '没有更多数据'
            classType = 'noData'
          }
          return classType
        }
      }
    }
  },
  data() {
    return {
      title: '消息中心',
      rightContent: 'isNo',
      messageList: [
        { name: '重要公告', type: 1 },
        { name: '系统维护', type: 3 },
        { name: '最新优惠', type: 4 },
        { name: '行情提醒', type: 7 }
      ],
      isScroll: '',
      list: '',
      moreTxt: '',
      isNewNotice: false,
      noticeNum: 10,
      systemNum: 10,
      newNum: 10,
      quotesNum: 10
    }
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.hasScrollbar()
    if (!this.tabIndex) this.$store.dispatch('setTabIndex', 1)
    this.initNotice(this.tabIndex)
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.hasScrollbar()
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    hasScrollbar() {
      if (document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight)) {
        this.isScroll = true
      } else this.isScroll = false
      return this.isScroll
    },
    tabClick(index, type) {
      this.list = ''
      this.$store.dispatch('setTabIndex', type)
      this.initNotice(this.tabIndex)
    },
    initNotice(obj) {
      const data = {
        index: 1,
        pageSize: 10,
        noticeType: obj
      }
      this.noticeData(data)
    },
    noticeData(data) {
      api.getNoticeList(this.$qs.stringify(data)).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data
        }
      })
    },
    clickMore() {
      let data = {}
      if (this.moreTxt == '加载更多') {
        if (this.tabIndex == 0) {
          this.noticeNum += 10
          data = {
            index: 1,
            pageSize: this.noticeNum,
            noticeType: 1
          }
        } else if (this.tabIndex == 1) {
          this.systemNum += 10
          data = {
            index: 1,
            pageSize: this.systemNum,
            noticeType: 3
          }
        } else if (this.tabIndex == 2) {
          this.newNum += 10
          data = {
            index: 1,
            pageSize: this.newNum,
            noticeType: 4
          }
        } else if (this.tabIndex == 3) {
          this.quotesNum += 10
          data = {
            index: 1,
            pageSize: this.quotesNum,
            noticeType: 7
          }
        }
        this.noticeData(data)
      }
    },
    goMessageDetail(id) {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/messageDetail', query: { id: id }})
    }
  }
}
</script>
